import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="form-submit"
export default class extends Controller {

    submit() {
        if (typeof (this.element as HTMLFormElement).requestSubmit === "function") {
            (this.element as HTMLFormElement).requestSubmit()
        } else {
            (this.element as HTMLFormElement).submit()
        }
    }
}
